import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  GetRadniNalogQuery,
  RadniNalogDto, RadniNaloziClient,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RadniNalogResolver
  extends BaseService
  implements Resolve<RadniNalogDto> {
  constructor(private _client: RadniNaloziClient) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<RadniNalogDto> | Promise<RadniNalogDto> | RadniNalogDto | null {
    const id = Number.parseInt(route.paramMap.get('id'));
    return this._client.get(new GetRadniNalogQuery({ id: id })).pipe(
      map((x) => x.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
